module.exports = __webpack_public_path__ + "img/gq.06c8f0e1.svg";